// Mock data for Yetkin Dienstleistungen website

export const navigationLinks = [
  { id: 1, name: 'Über uns', path: '/about' },
  { id: 2, name: 'Dienstleistungen', path: '/services' },
  { id: 3, name: 'Nachricht', path: '/news' },
  { id: 4, name: 'Partner & Sponsoren', path: '/partners' },
  { id: 5, name: 'Karriere', path: '/careers' },
  { id: 6, name: 'Kontakt', path: '/contact' }
];

export const heroContent = {
  tagline: 'Exzellenz in Hospitality',
  headline: 'Zuverlässige Gastgewerbe',
  subheadline: 'Personal-Lösungen',
  description: 'Gastgewerbebetriebe mit qualifizierten Fachkräften stärken',
  ctaText: 'Personal jetzt anfordern',
  videoUrl: '/media/0f5vqssu_Yetkin_main_video.mp4'
};

export const services = [
  {
    id: 1,
    title: 'Housekeeping Services',
    subtitle: 'Makellose Sauberkeit',
    description: 'Verlassen Sie sich auf Profis. Wir bieten geschultes Reinigungspersonal und Supervisoren, die Sauberkeit zur Priorität machen. Schaffen Sie eine sichere Wohlfühl-Atmosphäre, die Ihre Gäste lieben werden.',
    image: '/media/cmais6nz_HSK.jpg',
    videoUrl: '/media/1sbx9sm4_Yetkin_Housekeeping_FHD-.mp4',
    icon: 'sparkles'
  },
  {
    id: 2,
    title: 'Front Office, Concierge und Bell Staff Services',
    subtitle: 'Erster Eindruck zählt',
    description: 'Unser Front Office-Team ist das Gesicht Ihres Hotels. Wir garantieren herzliche Begrüßungen, reibungslose Check-ins und mehrsprachigen Service. Für einen Empfang, der Ihren Gästen im Gedächtnis bleibt.',
    image: '/media/xm9l9h1w_FO.jpg',
    videoUrl: '/media/nw03zfni_Yetkin_Front_office_FHD_1.mp4',
    icon: 'users'
  },
  {
    id: 3,
    title: 'Fensterreinigungsdienste',
    subtitle: 'Kristallklare Sicht',
    description: 'Ob Lobbyfassade oder Gästezimmer: Unser spezialisiertes Team sorgt für streifenfreien Glanz im Innen- und Außenbereich. Wir garantieren kristallklare Fenster und ein strahlendes Erscheinungsbild.',
    image: '/media/z76vhwok_Window.jpg',
    videoUrl: '/media/5sedr1h5_Yetkin_Window_cleaning_FHD_1.mp4',
    icon: 'grid3x3'
  },
  {
    id: 4,
    title: 'Küchen-, Stewarding- und Bankett-Services',
    subtitle: 'Kulinarische Exzellenz',
    description: 'Von der Vorbereitung bis zum Servieren: Wir stellen erstklassige Teams für Küche, Stewarding und Bankett. Mit Fachwissen und Leidenschaft sorgen wir für ein nahtloses Speiseerlebnis und höchste Lebensmittelsicherheit in Ihrem Betrieb.',
    image: '/media/jnolp16v_kitchen.jpg',
    videoUrl: '/media/5fjmjfr3_Yetkin_kitchen_stuff_FHD_1.mp4',
    icon: 'chefHat'
  }
];

export const benefits = [
  {
    id: 1,
    title: 'Professionelles Personal',
    description: 'Qualifizierte und erfahrene Fachkräfte',
    icon: 'award'
  },
  {
    id: 2,
    title: 'Zuverlässiger Service',
    description: 'Pünktlich und verlässlich rund um die Uhr',
    icon: 'clock'
  },
  {
    id: 3,
    title: 'Gäste Zufriedenheit',
    description: 'Höchste Standards für Ihre Gäste',
    icon: 'heart'
  },
  {
    id: 4,
    title: 'Flexible Lösungen',
    description: 'Angepasst an Ihre Bedürfnisse',
    icon: 'settings'
  }
];

export const sponsor = {
  name: 'Alba Berlin',
  description: 'Unterstützung des professionellen Basketballs in Berlin mit unserem Engagement für Exzellenz in Hospitality-Dienstleistungen.',
  logo: '/media/6nm3v4qi_ALBA_Logo_RGB.png'
};

export const partners = [
  { id: 1, name: 'Revo Hospitality Group', logo: '/media/rid6bj22_REVO.jpeg' },
  { id: 2, name: 'Louvre Hotels', logo: '/media/qmpgw7cq_0Yi5mp69_400x400.jpg' },
  { id: 3, name: 'Motel One', logo: '/media/1wb3r7ka_motel-one-logo-klein.webp' },
  { id: 4, name: 'H-Hotels', logo: '/media/4vs2c4kn_h-hotels-logo.jpeg' },
  { id: 5, name: 'Titanic Hotels', logo: '/media/bs0kcfuz_titanic-hotels.png' },
  { id: 6, name: 'Leonardo Hotels', logo: '/media/karv48df_leonardo-hotels-logo.webp' },
  { id: 7, name: 'Ibis Hotels', logo: '/media/apcd57oc_Logo_Ibis-Hotel_2012.png' }
];

export const aboutContent = {
  name: 'Cagdas Yetkin',
  role: 'Geschäftsführer',
  image: '/media/0dy89oha_Cagdass.png',
  bio: [
    'Ausgebildet in der 5-Sterne-Hotellerie, erkannte ich schnell meine Leidenschaft für den Beruf des Hotel-Concierge. Nach meiner Ausbildung folgte ich dem klassischen Weg vom Pagen zum Concierge, bis ich mich schließlich selbstständig machte und seit 2018 mit meinem Team aus erfahrenen Hotel-Concierges mehrere Hotels in Berlin unterstütze.',
    'Geprägt von den Schwierigkeiten der Pandemie, formte sich in mir die Idee der Veränderung, und so fand ich einen Weg, das Geschäft zu erweitern. Seit 2021 unterstütze ich mehrere Hotels in Berlin und Brandenburg im Bereich Housekeeping.',
    'Für mich ist exzellenter Service genauso wichtig wie Sauberkeit und Hygiene im Unternehmen. Ich bin täglich persönlich im Einsatz, um Sie in diesen Bereichen zu unterstützen und stehe im Notfall fast rund um die Uhr zur Verfügung, um jederzeit reagieren zu können.'
  ]
};

export const contactInfo = {
  title: 'Kontaktaufnahme',
  subtitle: 'Haben Sie eine Frage oder möchten Sie mit uns zusammenarbeiten? Senden Sie uns eine Nachricht und wir melden uns bald bei Ihnen.',
  fields: [
    { name: 'firstName', label: 'Vorname', type: 'text', required: true },
    { name: 'lastName', label: 'Nachname', type: 'text', required: true },
    { name: 'email', label: 'E-Mail', type: 'email', required: true },
    { name: 'subject', label: 'Betreff', type: 'text', required: true },
    { name: 'message', label: 'Nachricht', type: 'textarea', required: true }
  ]
};

export const footerContent = {
  company: 'Yetkin Dienstleistungen',
  tagline: 'Exzellenz in Hospitality-Dienstleistungen',
  copyright: '© 2025 Yetkin Dienstleistungen. Alle Rechte vorbehalten.',
  socialLinks: [
    { name: 'LinkedIn', url: '#' },
    { name: 'Instagram', url: '#' },
    { name: 'Facebook', url: '#' }
  ]
};
